// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.follows .target {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.follows .target .targetInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.follows .target .targetInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.follows .target .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.follows .target .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.follows .target .buttons button:first-child {
  background-color: #5271ff;
}
.follows .target .buttons button:last-child {
  background-color: #f0544f;
}`, "",{"version":3,"sources":["webpack://./src/components/latest_targets/latest.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAFR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAFV;AAGU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADZ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAHR;AAKQ;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAHZ;AAKY;EACA,yBAAA;AAHZ;AAMY;EACA,yBAAA;AAJZ","sourcesContent":["@import \"../../style.scss\";\n\n.follows{\n    .target {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin: 20px 0px;\n\n        .targetInfo {\n          display: flex;\n          align-items: center;\n          gap: 20px;\n          position: relative;\n          flex-wrap: wrap;\n          img {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n        }\n\n    .buttons {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        flex-wrap: wrap;\n\n        button {\n            border: none;\n            padding: 5px;\n            color: white;\n            cursor: pointer;\n\n            &:first-child {\n            background-color: #5271ff;\n            }\n\n            &:last-child {\n            background-color: #f0544f;\n            }\n        }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
